import React from 'react';
import AllMyPost from '../AllMyPost/AllMyPost';
import CreateRoom from '../CreateRoom/CreateRoom';
import Header from '../Header/Header';
import NewPost from '../NewPost/NewPost';
import LeftSide from '../Sidebar/LeftSide';
import RightSide from '../Sidebar/RightSide';
import Story from '../Story/Story';
import './Home.css';
import { useHistory } from 'react-router';



const Home = ({user}) => {
  document.title = `Aisbook | ${user.displayName}`;
  
  const history = useHistory("");
  if (!user) {
    history.push("/login")
  }  

    return ( 
        <div>
            <div className="home">
              <Header user={user}/>
                <div className="row"> 
                <div className="col-lg-3 homeLeft"><LeftSide user={user}/></div>
                <div className="col-lg-6 col-md-9 homeMiddle mb-5">
                    <Story user={user}/>
                    <div className="homeMdl">
                      <NewPost user={user}/>
                      <CreateRoom user={user}/>
                      <AllMyPost user={user}/>
                    </div>
                </div>
                <div className="col-lg-3 col-md-3 homeRight"><RightSide user={user}/></div>
              </div>
            </div>
            
        </div>
    );
};

export default Home;